export default __webpack_public_path__ + "static/media/l3.0c253d8c.jpg";